export default class SettingCtrl {
    constructor($state, $stateParams, SideMenu) {
        SideMenu.setActive('setting');

        this.status = $stateParams.folder || 'sender';
        this._state = $state;
    }
    
    setStatus(status) {
        this._state.go('setting.folder', { folder: status });
    };
}
